module.exports = __webpack_public_path__ + "static/media/uvd-logo-neg.9cbfb1e1.svg";